import ElementPlus from 'element-plus'
import '../theme.scss'

export default (app) => {
  app.use(ElementPlus)
}
